export const theme = {
  borderColor: 'none',
  disabledBorderColor: 'none',
};
